import { LineFileUpload } from '@qr-front/icons/line-file-upload'
import { ReactElement } from 'react'

import { cn, getVersionForClone } from '@/utils'

const borderCls = getVersionForClone({
	base: 'rounded-10',
	clone1: 'rounded-full',
})

export const Dropzone = ({
	title,
	description,
	placeholderIcon,
}: {
	title: string
	description: string
	placeholderIcon?: ReactElement
}) => (
	<div className="flex items-center gap-2 tablet:gap-4">
		<div
			className={cn(
				'flex size-20 shrink-0 items-center justify-center border border-border-grey-50 bg-white',
				borderCls,
			)}
		>
			<div
				className={cn(
					'size-16 bg-light-blue p-4 text-blue [&_svg]:size-8',
					borderCls,
				)}
			>
				{placeholderIcon || <LineFileUpload />}
			</div>
		</div>
		<div className="flex flex-col items-start gap-1 text-start">
			<h5 className="type-body-medium px-2 font-semibold">{title}</h5>
			<small className="type-body-small px-2 text-dark-grey">
				{description}
			</small>
		</div>
	</div>
)
